/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import { RootState } from "../../../../redux/Reducer";
import { useSelector, useDispatch } from "react-redux";
import ActionCard from "./actionCard";
import MeetingSummary from "./meetingSummary";
import { GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS } from "../../../../redux/Action/actionTypes";

interface Props {
  roundName: string;
  roundNumber: number;
  isEditDisabled: boolean;
}
const NegotiationRoundOverview = ({ roundNumber, roundName, isEditDisabled }: Props) => {
  const [negotiationRoundActionCards, setNegotiationRoundActionCards] =
    useState<object[]>([]);
  const [summary, setSummary] = useState<string>("");
  const [notes, setNotes] = useState<string>("");
  const negotiationContractData = useSelector(
    (state: RootState) => state.dashboardData.detailedOverviewData
  );
  const dispatch = useDispatch();
  const [communicationMethod, setCommunicationMethod] = useState<string>("")

  useEffect(() => {
    if (Object.keys(negotiationContractData).length > 0) {
      let negotiationRoundArr: any = [];
      let summaryText: string = "";
      let communicationMethod: string = ""
      let notesValue = "";
      negotiationContractData.planNegotiationActions.negotiationRoundsDetails
        .length &&
        negotiationContractData.planNegotiationActions.negotiationRoundsDetails.map(
          (data: any) => {
            if (data.roundName === roundName) {
              negotiationRoundArr = data.selectedAction;
              summaryText = data.meetingSummary;
              communicationMethod = data.communicationMethod
              notesValue = data.meetingNotes
            }
          }
        );
      setNegotiationRoundActionCards(negotiationRoundArr);
      setSummary(summaryText);
      setNotes(notesValue)
      setCommunicationMethod(communicationMethod || "");
    }
  }, [negotiationContractData, roundName]);

  const handleCheckboxChange = (id: string) => {
    setNegotiationRoundActionCards((prevCardArr) =>
      prevCardArr.map((item: any) =>
        item.id === id
          ? { ...item, isNegotiationActionUsed: !item.isNegotiationActionUsed }
          : item
      )
    );

    negotiationContractData.planNegotiationActions.negotiationRoundsDetails
      .length &&
      negotiationContractData.planNegotiationActions.negotiationRoundsDetails.map(
        (data: any) => {
          if (data.roundName === roundName) {
            let newArr: any = [];
            newArr =
              data.selectedAction.length &&
              data.selectedAction.map((item: any) =>
                item.id === id
                  ? {
                    ...item,
                    isNegotiationActionUsed: !item.isNegotiationActionUsed,
                  }
                  : item
              );
            data.selectedAction = newArr;
          }
        }
      );
    dispatch({
      type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
      payload: negotiationContractData,
    });
  };

  const communicationMethodHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let value: any = e.target?.value ? e.target?.value : "";
    setCommunicationMethod(value);
    negotiationContractData.planNegotiationActions.negotiationRoundsDetails
      .length &&
      negotiationContractData.planNegotiationActions.negotiationRoundsDetails.map(
        (data: any) => {
          if (data.roundName === roundName) {
            data.communicationMethod = value;
          }
        }
      );

    dispatch({
      type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
      payload: negotiationContractData,
    });
  }
 const handleInputChange = (cardId: string, value: string) => {
     const updatedCards = negotiationRoundActionCards.map((item: any) =>
       item.id === cardId ? { ...item, implementationApproach: value } : item
     );
     setNegotiationRoundActionCards(updatedCards);
     const updatedData = { ...negotiationContractData };
     updatedData.planNegotiationActions.negotiationRoundsDetails = updatedData.planNegotiationActions.negotiationRoundsDetails.map(
       (round: any) =>
         round.roundName === roundName
           ? {
               ...round,
               selectedAction: round.selectedAction.map((item: any) =>
                 item.id === cardId
                   ? { ...item, implementationApproach: value }
                   : item
               ),
             }
           : round
     );
     dispatch({
       type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
       payload: updatedData,
     });
   };
  return (
    <div className="negotiation-round-actions-overview">
      <div className="row mb-2 mt-2">
        <div className="negotiation-round-communication-method-box">
          <div className="col-4">
            <div className="negotiation-round-communication-method-header">Communication method used in this round : </div>
          </div>
          <div className="col-3">
            <select className="form-select custom-select" value={communicationMethod} onChange={communicationMethodHandler}>
              <option value="" disabled>{` select `}</option>
              <option value="Teams-Meeting">Teams-Meeting</option>
              <option value="Personal Meeting">Personal Meeting</option>
              <option value="Phone-Call">Phone-Call</option>
              <option value="Only via Mail">Only via Mail</option>
            </select>
          </div>
        </div>
      </div>

      <div className="negotiation-round-actions-overview-heading">
        Summary of negotiation round {roundNumber} :
      </div>
      <div className="row">
        <MeetingSummary summary={summary} roundName={roundName} />
      </div>

      <div className="negotiation-round-actions-overview-heading">Additional Notes :</div>
      <div className="row">
        <MeetingSummary summary={notes} roundName={roundName} negotiationStatus={"inProgress"} closeNegotiationPlaceholder={"Please enter the additional notes and hyperlinks..."} />
      </div>

      <div className="negotiation-round-actions-overview-heading">
        Round {roundNumber} actions :
      </div>
      <div className="row">
        {negotiationRoundActionCards.length > 0 ? (
          negotiationRoundActionCards.map((data: any, index: number) => {
            return (
              <ActionCard
                key={data.id}
                contractData={data}
                handleCheckboxChange={handleCheckboxChange}
                onInputChange={(value) => handleInputChange(data.id, value)}
                isEditDisabled={isEditDisabled}
              />
            );
          })
        ) : (
          <div className="negotiation-no-data-message">
            Plan Negotiation Actions are not available.
          </div>
        )}
      </div>
    </div>
  );
};

export default NegotiationRoundOverview;
